import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useReactToPrint } from "react-to-print";
import { Card, Box, Typography, IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useParams } from "react-router-dom";

const BonafideDoc = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { student } = location.state || {}; // Access the student data from state
  const componentRef = useRef();
  const [printMode, setPrintMode] = useState("");
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(true);
  const [originalData, setOriginalData] = useState([]); // Original API data
  const [filteredData, setFilteredData] = useState([]);

  const { admissionNumber } = useParams();

  // Handle PDF Download
  const handleDownload = async () => {
    const element = document.querySelector("#certificate-container");
    const canvas = await html2canvas(element, { useCORS: true });
    const image = canvas.toDataURL("image/png");

    const pdf = new jsPDF("l", "mm", "a4"); // 'l' for landscape
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(image, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("Bonafide_Certificate.pdf");
  };

  // Handle Print
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Bonafide Certificate",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${baseUrl}/api/bonafideAdmission/getStudentBonafideDetails/${admissionNumber}`
        );
        const data = await response.json();
        setOriginalData(data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const PrintableSection = React.forwardRef((props, ref) => (
    <div
      ref={ref}
      id="certificate-container"
      style={{
        textAlign: "center",
        position: "relative",

        width: "200mm",
        height: "120mm",
        marginTop: "20px",

        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#F9F6DC",
      }}
    >
      <img
        src="/assets/border.png"
        alt="Border Image"
        style={{
          // width: "100%",
          width: "200mm",

          height: "120mm",
          display: "block",
          position: "absolute",
          backgroundColor: "#F9F6DC",
        }}
      />

      <div
        id="certificate"
        style={{
          position: "absolute",
          // top: "0",
          // left: "0",
          // width: "100%",
          width: "200mm",
          height: "120mm",
          // height: "100%",
          padding: "1px",
          fontStyle: "italic",
        }}
      >
        <h2 style={{ marginTop: "35px", fontStyle: "normal" }}>
          BONAFIDE CERTIFICATE
        </h2>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 50px",
          }}
        >
          <p style={{ fontStyle: "normal" }}>
            <strong>Admission No:</strong>
            {admissionNumber || props.student?.admissionNo || ""}
          </p>
          <p style={{ fontStyle: "normal" }}>
            <strong>Date:</strong>
            {originalData.admissionDate || props.student?.dateOfIssue || "_"}
          </p>
        </div>
        <div style={{ textAlign: "left", padding: "0 50px" }}>
          <p>
            This is to certify that Master/Kumari <></>
            <span
              style={{
                textDecoration: "underline",
              }}
            >
              <strong>
                {originalData.surName} {originalData.firstName}&nbsp;
                {originalData.lastName}
              </strong>
            </span>
            <span
              style={{
                marginLeft: "5px",
                marginRight: "5px",
                // borderBottom: "1px solid black",
              }}
            >
              {props.student?.studentName || ""}
            </span>
            , S/o, D/o
            <span
              style={{
                marginLeft: "5px",
                // borderBottom: "1px solid black",
                textDecoration: "underline",
              }}
            >
              {(
                <strong>
                  {/* {originalData.surName}&nbsp; */}
                  {originalData.fathersFirstName}&nbsp;
                  {originalData.fathersLastName}
                </strong>
              ) ||
                props.student?.fatherName ||
                ""}
            </span>
            ,&nbsp; is / was a bonafide student of this institution.
          </p>
        </div>
        <div style={{ textAlign: "left", padding: "0 50px" }}>
          <p>
            He/She studying/studied from &nbsp;
            <span
              style={{
                textDecoration: "underline",
              }}
            >
              <strong>{originalData.studentJoinedClass}</strong>
            </span>
            &nbsp;year&nbsp;
            <span
              style={{
                textDecoration: "underline",
              }}
            >
              <strong>{originalData.studentJoinedYear}</strong>
            </span>
            &nbsp;to &nbsp;
            <span
              style={{
                textDecoration: "underline",
              }}
            >
              <strong>{originalData.romanNumberClass}</strong>
            </span>
            &nbsp;year&nbsp;
            <span
              style={{
                textDecoration: "underline",
              }}
            >
              <strong>{originalData.academicYear}</strong>&nbsp;
            </span>
            &nbsp;During his/her study period. <br />
            <br />
            his/her character was found good.
          </p>
          <p>
            His/Her date of birth according to the school Admission register
            is&nbsp;
            <span
              style={{
                textDecoration: "underline",
              }}
            >
              <strong>{originalData.dob}</strong>
            </span>
            {props.student?.dateOfBirth || ""}
          </p>
        </div>
        <div
          className="head-master-section"
          style={{
            textAlign: "right",
            padding: "0 50px",
            marginTop: "50px",
          }}
        >
          <p>Head Master/Principal</p>
        </div>
      </div>
    </div>
  ));

  return (
    <Card
      className={`main-card ${printMode}`}
      style={{
        borderRadius: "16px",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#f4f6f9",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: "1px",
        marginTop: "49px",
        height: "100vh",
        padding: "20px",
        margin: "60px 1% 1%",
        position: "relative",
        // width: "100%",
      }}
    >
      <PrintableSection ref={componentRef} student={student} />

      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "20px",
          display: "flex",
          flexDirection: "row",
          gap: "10px",
        }}
      >
        <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
          <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
            BONAFIDE CERTIFICATE
          </Typography>
        </Box>
      </div>

      {/* Buttons for Download & Print at Top Right */}
      <div
        className="print-hide"
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          display: "flex",
          flexDirection: "row",
          gap: "10px",
        }}
      >
        {/* <button
          onClick={handleDownload}
          style={{
            padding: "8px 16px",
            borderRadius: "8px",
            color: "#fff",
            cursor: "pointer",
            background: "linear-gradient(90deg, #ff7eb3, #ff758c)",
            border: "none",
            fontWeight: "bold",
            fontSize: "14px",
            transition: "all 0.4s ease",
            boxShadow: "0 5px 10px rgba(255, 117, 140, 0.3)",
          }}
        >
          Download
        </button> */}
        <button
          onClick={handlePrint}
          style={{
            padding: "8px 16px",
            borderRadius: "8px",
            color: "#fff",
            cursor: "pointer",
            background: "linear-gradient(90deg, #3C3972, #3C3972)",
            border: "none",
            fontWeight: "bold",
            fontSize: "14px",
            transition: "all 0.4s ease",
            boxShadow: "0 5px 10px rgba(30, 144, 255, 0.3)",
          }}
        >
          Print
        </button>
      </div>

      {/* Print Styles */}
      <style>
        {`
          @media print {
            @page {
          
              //  size: 310mm ;
              // height: 190mm;

              //  size: 120mm  portrait;
  // margin: 10mm;
   
            }
            body {
              display: flex;
              justify-content: center;
              align-items: center;
              // height: 100vh;
              height:auto;
              background: white;
              width: 100%;
            }


            .main-card {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 210mm;
              height: 297mm;
              transform: scale(1);
              transform-origin: top center;
            }
            #certificate-container {
              // width: 100%;
              // height: 70vh !important;

              width: "200mm",
        height: "120mm",
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .print-hide {
              display: none;
            }
          }
        `}
      </style>
    </Card>
  );
};

export default BonafideDoc;